import Vue from 'vue'
import App from './App.vue'
import promise from 'es6-promise'
import router from './router/index.js'
import axios from './axios/index.js'
import './assets/css/common.scss'

Vue.prototype.$ajax = axios
Vue.config.productionTip = false
promise.polyfill()
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
